import { fabric } from 'fabric'
import { FabricJSCanvas, useFabricJSEditor } from 'fabricjs-react'
import { useEffect, useRef, useState } from 'react'
import { useImageStore } from '../stores/ImageStore'
import { useCamTargetStore } from '../stores/CamTargetStore'
import { useModelDataStore } from '../stores/ModelDataStore'

export default function ImageEditor(props) {
    const fileInput = useRef()
    const [canvas, setCanvas] = useState()
    let updateImageContent = useImageStore((state) => state.updateContent)

    const overlayCanvas = useRef()
    let uvSize = useModelDataStore((state) => state.uvSize) 
    let labelSize = useModelDataStore((state) => state.labelSize)
    let labelOffset = useModelDataStore((state) => state.labelOffset)
    const [currentLabelSize, setCurrentLabelSize] = useState(labelSize)
    const [currentLabelOffset, setCurrentLabelOffset] = useState(labelOffset)

    useEffect(() => {
        // setCanvas(new fabric.Canvas('canvas', {height: 585, width: 1040}))
        setCanvas(new fabric.Canvas('canvas', {height: 585, width: 1040}))
        // setCanvas(new fabric.Canvas('canvas', {height: 545, width: 737})) // Multiplying mins
    }, [])

    useEffect(() => {
        canvas?.setBackgroundColor(null)
        canvas?.on("mouse:up", () => {
            // if (!props.isVisible) return;
            updateImageContent(canvas?.toDataURL())
        })
        canvas?.wrapperEl.appendChild(overlayCanvas.current) // Set overlay canvas (labels) to be canvas-container's child
    }, [canvas])

    useEffect(() => {
        // console.log(labelSize);
        setCurrentLabelSize(labelSize) // TODO - Add UVSize and LabelOffset
        setCurrentLabelOffset(labelOffset)
    }, [uvSize, labelSize, labelOffset])

    const loadImage = (event) => {
        let reader = new FileReader();
        reader.onload = function (e) {
            fabric.Image.fromURL(e.target.result, function (oImg) {
                if (!props.isVisible) return;
                canvas?.add(oImg);
                if (oImg.width > canvas?.width * .8 || oImg.height > canvas?.height * .8) {
                    oImg.scaleToWidth(canvas?.width / 2);
                }
                oImg.center();
                oImg.setCoords();
                setTimeout(() => {
                    canvas.setBackgroundColor(null)
                    updateImageContent(canvas.toDataURL());
                }, 1000)
            });
        };
        reader.readAsDataURL(event.target.files[0]);
    }

    return <>
        {/* <h3 style={{ marginBottom: "10px", width: "fit-content", cursor: "pointer" }}
            onClick={() => props.setVisibility()}
        >
            Label editor
        </h3> */}
        <div style={{ display: (props.isVisible ? "block" : "none") }}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: "1rem"}}>
                <button className="round-button" style={{marginBottom: "15px"}} onClick={() => props.setVisibility()}> 
                    BACK
                </button>
                <img style={{ height: "3rem", margin: ".5rem", marginBottom: "15px" }} src="/templates.png" 
                    onClick={() => window.open(props.templateUrl)}
                />
                <input
                    ref={fileInput}
                    onChange={loadImage}
                    type={"file"}
                    accept="image/*"
                    style={{ marginBottom: "15px", marginRight: "0", marginTop: "1rem" }}>
                </input>
            </div>
            <canvas ref={overlayCanvas} id='canvasOverlay' style={{ position: "absolute", width: currentLabelSize.x, height: currentLabelSize.y,
                top: currentLabelOffset.y, left: currentLabelOffset.x,
                transform: "translateX(-16rem)", borderRadius: ".5em", border: "solid .15em #cc44449d", touchAction: "none", userSelect: "none", pointerEvents: "none"
            }}>
                
            </canvas>
            <canvas id='canvas' className="sample-canvas"></canvas>
            {/* <FabricJSCanvas
                className="sample-canvas"
                onReady={() => onReady(editor)}
            /> */}
        </div>
    </>

}